import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';

export function ModalSeleccionarTipoSalida({ open, onClose, onSeleccionar }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle>¿Qué tipo de movimiento?</DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography variant="body2" sx={{ mb: 3 }}>
          Selecciona si es una salida simple o una venta
        </Typography>
      </DialogContent>
      <DialogActions sx={{ flexDirection: 'column', gap: 1, p: 2 }}>
        <Button fullWidth variant="contained" color="error" onClick={() => onSeleccionar('SALIDA')}>
          Salida Simple
        </Button>
        <Button fullWidth variant="contained" color="warning" onClick={() => onSeleccionar('VENTA')}>
          Venta (con precio unitario)
        </Button>
        <Button fullWidth variant="outlined" onClick={onClose}>
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
